import { render, staticRenderFns } from "./ProductivityReason.vue?vue&type=template&id=c62c8fe4&scoped=true"
import script from "./ProductivityReason.vue?vue&type=script&lang=js"
export * from "./ProductivityReason.vue?vue&type=script&lang=js"
import style0 from "./ProductivityReason.vue?vue&type=style&index=0&id=c62c8fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62c8fe4",
  null
  
)

export default component.exports